import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import LocalesSection from "../sections/LocalesSection";

export function LocalesPage({ auth, locales }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Локали"
        description="Редактируйте ключи переводов, тексты с плейсхолдерами и языковые варианты."
      />
      <PageContent>
        <LocalesSection
          mode="page"
          adminToken={auth.adminToken}
          localeLang={locales.state.localeLang}
          localesList={locales.state.localesList}
          localeData={locales.state.localeData}
          localeInitialData={locales.state.localeInitialData}
          localeSaving={locales.state.localeSaving}
          localeDirty={locales.state.localeDirty}
          onLocaleLangChange={locales.actions.setLocaleLang}
          onLocaleChange={locales.actions.setLocaleData}
          onReload={locales.actions.reload}
          onSave={locales.actions.save}
        />
      </PageContent>
    </div>
  );
}

export default LocalesPage;
